export const LOGIC_TEST_VALIDATION_BASE_URL = '/logic-test-validation';

export const LOGIC_TEST_VALIDATION_LINKS = {
    start: () => `${LOGIC_TEST_VALIDATION_BASE_URL}`,
    test: (testId: string) => `${LOGIC_TEST_VALIDATION_BASE_URL}/${testId}`
};
